<template>
  <div class="card card-custom gutter-b p-5">
    <div class="py-2">
      <p class="float-left font-weight-bolder font-size-h3 text-dark-75">
        {{ namaKegiatan }}
      </p>
    </div>
    <div style="overflow-x: hidden; overflow-y: hidden" class="pt-2">
      <table
        id="example"
        class="table table-striped table-bordered"
        style="width: 100%"
      >
        <thead>
          <tr>
            <th style="width: 10px">No</th>
            <th>Nama Peserta</th>
            <th>NIP</th>
            <th>DPMPTSP</th>
            <th>Jenis Kelamin</th>
            <th>Nilai Pre-Test</th>
            <th>Nilai Post-Test</th>
            <th>Status Nilai</th>
            <th>Kartu Identitas</th>
            <th>Survey</th>
            <th>Sertifikat</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in daftarPeserta" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ row.nama_user }}</td>
            <td>{{ row.nip }}</td>
            <td>{{ row.ptsp }}</td>
            <td>{{ row.jenis_kelamin }}</td>
            <td>{{ row.nilai_pre_test }}</td>
            <td>{{ row.nilai_post_test }}</td>
            <td>
              <b-button
                v-if="parseFloat(row.nilai_pre_test) < parseFloat(row.nilai_post_test)"
                variant="outline-success"
                size="sm"
                ><i class="fa fa-arrow-up mr-1"></i>Naik</b-button
              >
              <b-button
                v-else-if="parseFloat(row.nilai_pre_test) === parseFloat(row.nilai_post_test)"
                variant="outline-secondary"
                size="sm"
                ><i class="fa fa-arrows-alt-h mr-1"></i>Sama</b-button
              >
              <b-button v-else variant="outline-danger" size="sm"
                ><i class="fa fa-arrow-down mr-1"></i>Turun</b-button
              >
            </td>
            <td class="text-center" ><b-button variant="primary" v-b-tooltip.hover
              title="Lihat Kartu Identitas" @click="lihatIdentias(row.id_user)"><i class="fa fa-address-card"></i></b-button></td>
            <td style="text-align: center">
              <b-button
                variant="info"
                size="sm"
                @click="lihatSurvey(row.id_user)"
                class="m-1"
                v-b-tooltip.hover
                title="Lihat Survey"
                ><i class="fa fa-file"></i
              ></b-button>
            </td>
            <td style="text-align: center">
              <b-button
                v-if="row.file_sertifikat !== null"
                @click="exportSertifikat(row.file_sertifikat)"
                size="sm"
                variant="success"
                class="m-1 pr-2"
                ><i class="flaticon-download-1"></i
              ></b-button>
            </td>
            <td>
              <b-button
                variant="danger"
                size="sm"
                @click="deleteData(row.id)"
                class="m-1"
                v-b-tooltip.hover
                title="Hapus Peserta"
                ><i class="flaticon2-trash"></i
              ></b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-modal id="modal-tambah" title="Tambah Peserta" hide-footer>
      <div class="form-group">
        <s-select
          :options="dataPeserta"
          v-model="form.id_user"
          :reduce="(data) => data.id"
          label="name"
          placeholder="Pilih Peserta"
        ></s-select>
      </div>
      <div>
        <b-button class="float-right" variant="success" @click="submitData">
          Tambah
        </b-button>
        <b-button class="float-right mr-2" variant="danger"> Batal </b-button>
      </div>
    </b-modal>

    <b-modal
      id="modal-survey"
      :title="dataSurvey.nama_user"
      hide-footer
      size="xl"
    >
      <table class="table">
        <thead>
          <tr>
            <th>No.</th>
            <th>Pertanyaan</th>
            <th>Jawaban</th>
          </tr>
        </thead>
        <tbody>
          <tr class="bg-secondary">
            <td><strong>A.</strong></td>
            <td colspan="2"><strong> Pelaksanaan</strong></td>
          </tr>
          <tr>
            <td>1</td>
            <td>
              Menurut Bapak/Ibu bermanfaatkah kegiatan Peningkatan Kinerja PTSP
              dan Kinerja PPB Pemerintah Daerah ini?
            </td>
            <td>{{ dataSurvey.jawaban_a1 }}</td>
          </tr>
          <tr>
            <td>2</td>
            <td>
              Menurut Bapak/Ibu bagaimana tempat dan fasilitas dalam kegiatan
              Peningkatan Kinerja PTSP dan Kinerja PPB Pemerintah Daerah yang
              ada?
            </td>
            <td>{{ dataSurvey.jawaban_a2 }}</td>
          </tr>
          <tr>
            <td>3</td>
            <td>
              Menurut Bapak/Ibu bagaimana kesiapan panitia dalam melaksanakan
              kegiatan Peningkatan Kinerja PTSP dan Kinerja PPB Pemerintah
              Daerah?
            </td>
            <td>{{ dataSurvey.jawaban_a3 }}</td>
          </tr>

          <tr class="bg-secondary">
            <td><strong>B.</strong></td>
            <td colspan="2"><strong> Materi</strong></td>
          </tr>
          <tr>
            <td>1</td>
            <td>
              Menurut Bapak/Ibu bagaimana kesesuaian materi yang disampaikan
              dalam Peningkatan Kinerja PTSP dan Kinerja PPB Pemerintah Daerah
              dengan tugas dan fungsi pokok Bapak/Ibu?
            </td>
            <td>{{ dataSurvey.jawaban_b1 }}</td>
          </tr>
          <tr>
            <td>2</td>
            <td>
              Menurut Bapak/Ibu bagaimana kelengkapan materi yang disampaikan
              dalam Peningkatan Kinerja PTSP Peningkatan Kinerja PTSP dan
              Kinerja PPB Pemerintah Daerah?
            </td>
            <td>{{ dataSurvey.jawaban_b2 }}</td>
          </tr>
          <tr class="bg-secondary">
            <td><strong>C.</strong></td>
            <td colspan="2"><strong> Narasumber</strong></td>
          </tr>
          <tr>
            <td>1</td>
            <td>
              Secara umum, menurut Bapak/Ibu bagaimana penguasaan materi dari
              narasumber yang menyampaikan paparan materi?
            </td>
            <td>{{ dataSurvey.jawaban_c1 }}</td>
          </tr>
          <tr>
            <td>2</td>
            <td>
              Menurut Bapak/Ibu bagaimana cara narasumber materi ke-1 dalam
              menyampaikan materi?
            </td>
            <td>{{ dataSurvey.jawaban_c2 }}</td>
          </tr>
          <tr>
            <td>3</td>
            <td>
              Menurut Bapak/Ibu bagaimana cara narasumber materi ke-2 dalam
              menyampaikan materi?
            </td>
            <td>{{ dataSurvey.jawaban_c3 }}</td>
          </tr>
          <tr>
            <td>4</td>
            <td>
              Menurut Bapak/Ibu bagaimana cara narasumber materi ke-3 dalam
              menyampaikan materi?
            </td>
            <td>{{ dataSurvey.jawaban_c4 }}</td>
          </tr>
          <tr>
            <td>5</td>
            <td>
              Menurut Bapak/Ibu bagaimana cara narasumber materi ke-4 dalam
              menyampaikan materi?
            </td>
            <td>{{ dataSurvey.jawaban_c5 }}</td>
          </tr>
          <tr>
            <td>6</td>
            <td>
              Menurut Bapak/Ibu bagaimana cara narasumber materi ke-5 dalam
              menyampaikan materi?
            </td>
            <td>{{ dataSurvey.jawaban_c6 }}</td>
          </tr>
          <tr>
            <td>7</td>
            <td>
              Secara umum, menurut Bapak/Ibu bagaimana narasumber dalam menjawab
              pertanyaan dari peserta Peningkatan Kinerja PTSP dan Kinerja PPB
              Pemerintah Daerah?
            </td>
            <td>{{ dataSurvey.jawaban_c7 }}</td>
          </tr>
          <tr class="bg-secondary">
            <td colspan="3"><strong> Saran dan Harapan</strong></td>
          </tr>
          <tr>
            <td colspan="3">
              <div style="width: 500px" v-html="dataSurvey.saran_harapan"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>

    <b-modal id="modal-kartuidentitas" title="Kartu Identitas Peserta" hide-footer size="lg">
      <div class="form-group" v-if="kartu_identitas == null || kartu_identitas == ''">
        Tidak Ada Kartu Identitas!
      </div>
      <div v-else>
        <img width="100%" :src="kartu_identitas" alt="">
        
      </div>
      <div>
        
        <b-button
          class="float-right mr-2"
          variant="danger"
          @click="$bvModal.hide('modal-kartuidentitas')"
        >
          Tutup
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import VueSelect from "vue-select";
import Swal from "sweetalert2";

export default {
  name: "detailKegiatan",
  components: {
    "s-select": VueSelect,
  },
  data() {
    return {
      url: localStorage.getItem("baseapi"),
      token: localStorage.getItem("id_token"),
      daftarPeserta: [],
      namaKegiatan: "",
      dataPeserta: [],
      role: "admin_bimtek",
      form: {},
      statusVerifikasi: [
        { value: "Menunggu Verifikasi", text: "Menunggu Verifikasi" },
        { value: "Sudah Terverifikasi", text: "Sudah Terverifikasi" },
      ],
      dataSurvey: {},
      kartu_identitas: null
    };
  },
  mounted() {
    this.getNamaKegiatan();
    this.getdata();
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Detail Peserta" }]);
  },
  methods: {
    exportSertifikat(sert) {
      window.open(sert, "_blank");
    },
    getdata() {
      $("#example").DataTable().destroy();
      this.getNamaKegiatan();
      this.loaddata();
      this.getPeserta();
    },
    loaddata() {
      this.axios
        .get(
          `${this.url}/jadwal_peserta?filter=id_kegiatan,=,${this.$route.params.id};status_verifikasi,=,Sudah Terverifikasi`,
          {
            headers: {
              xth: this.token,
            },
          }
        )
        .then((response) => {
          const data = response.data.data;
          this.daftarPeserta = data;
          this.initDatatable();
        });
    },
    getNamaKegiatan() {
      this.axios
        .get(
          `${this.url}/jadwal_kegiatan?filter=id,=,${this.$route.params.id}`,
          {
            headers: {
              xth: this.token,
            },
          }
        )
        .then((response) => {
          const data = response.data.data;
          this.namaKegiatan = data[0].nama_kegiatan;
        });
    },
    getPeserta() {
      this.axios
        .get(`${this.url}/users?filter=id_role,=,peserta`, {
          headers: {
            xth: this.token,
          },
        })
        .then((response) => {
          this.dataPeserta = response.data.data;
        });
    },
    showModal() {
      this.$bvModal.show("modal-tambah");
    },
    submitData() {
      this.form.id_kegiatan = this.$route.params.id;
      if (this.form.id == null) {
        this.axios
          .post(`${this.url}/jadwal_peserta`, this.form, {
            headers: {
              xth: this.token,
            },
          })
          .then((response) => {
            this.$bvModal.hide("modal-tambah");
            this.form = {};
            this.getdata();
          });
      } else {
        this.axios
          .put(`${this.url}/jadwal_peserta/${this.form.id}`, this.form, {
            headers: {
              xth: this.token,
            },
          })
          .then((response) => {
            this.$bvModal.hide("modal-edit");
            this.form = {};
            this.getdata();
          });
      }
    },
    verifikasiData(id) {
      Swal.fire({
        title: "apakah anda yakin?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Batal",
        confirmButtonText: "Verifikasi!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .put(
              `${this.url}/jadwal_peserta/${id}`,
              { status_verifikasi: "Sudah Terverifikasi" },
              { headers: { xth: this.token } }
            )
            .then((response) => {
              Swal.fire({
                title: "Berhasil!",
                text: "Akun berhasil diverifikasi",
                icon: "success",
              });
              this.getdata();
            })
            .catch((error) => {
              Swal.fire({
                title: "Gagal!",
                text: "Terjadi kesalahan saat memverifikasi akun",
                icon: "error",
              });
            });
        }
      });
    },
    deleteData(id) {
      Swal.fire({
        title: "Apakah anda yakin?",
        text: "Data yang dihapus tidak dapat dikembalikan!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Batalkan",
        confirmButtonText: "Ya, hapus!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .delete(`${this.url}/jadwal_peserta/${id}`, {
              headers: {
                xth: this.token,
              },
            })
            .then((response) => {
              Swal.fire({
                title: "Berhasil!",
                text: "Data berhasil dihapus.",
                icon: "success",
              });
              this.getdata();
            });
        }
      });
    },

    lihatSurvey(id) {
      this.dataSurvey = {};
      this.axios
        .get(
          `${this.url}/survey_bimtek?filter=id_user,=,${id};id_kegiatan,=,${this.$route.params.id}`,
          {
            headers: {
              xth: this.token,
            },
          }
        )
        .then((response) => {
          const dataResponse = response.data.data;
          if (dataResponse.length != 0) {
            this.dataSurvey = dataResponse[0];
            this.$bvModal.show("modal-survey");
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Peserta belum melakukan survey",
            });
          }
        });
    },
    initDatatable() {
      setTimeout(() => {
        const t = $("#example").DataTable({
          pagingType: "full_numbers",
          language: {
            info: "Menampilkan _START_ sampai _END_ dari _TOTAL_ data",
            paginate: {
              first: "Awal",
              last: "Akhir",
              next: "Selanjutnya",
              previous: "Sebelumnya",
            },
          },
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          dom: "Bfrtip",
          buttons: [
            {
              extend: "excel",
              text: "Excel",
              title: "DAFTAR PERSERTA BIMTEK",
              exportOptions: {
                columns: [0, 1, 2, 3, 4, 5, 6, 7, 8],
                orthogonal: "export",
              },

              filename: function () {
                var today = new Date();
                // var n = d.getTime();
                var date =
                  today.getFullYear() +
                  "-" +
                  (today.getMonth() + 1) +
                  "-" +
                  today.getDate();

                return "Daftar Peserta Bimtek_" + date;
              },
            },
          ],
        });

        // t.on("order.dt search.dt", function () {
        //   t.column(0, { search: "applied", order: "applied" })
        //     .nodes()
        //     .each(function (cell, i) {
        //       cell.innerHTML = i + 1;
        //     });
        // }).draw();
      }, 300);
    },
    
    lihatIdentias(id){
      this.axios
        .get(`${this.url}/users/${id}`, {
          headers: {
            xth: this.token,
          },
        })
        .then((response) => {
          this.kartu_identitas = response.data.data.ijazah;
          this.$bvModal.show("modal-kartuidentitas");
        });
    }
  },
};
</script>
